// extracted by mini-css-extract-plugin
export var container = "Projects-module--container--9a264";
export var layout = "Projects-module--layout--106dd";
export var title = "Projects-module--title--a311a";
export var sliderWrapper = "Projects-module--sliderWrapper--bb01d";